import React from 'react';
import AdminTaxReportPanel from '../components/admin/AdminTaxReportPanel';

const AdminTaxReportPage = () => (
  <main className="min-h-[calc(100vh-64px)] bg-gray-50 px-4 py-8 sm:px-6 lg:px-8">
    <div className="mx-auto max-w-7xl">
      <AdminTaxReportPanel />
    </div>
  </main>
);

export default AdminTaxReportPage;